import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ILocalization, withLocalization } from 'bernie-l10n';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { SearchResultsStore } from 'stores/search-results-store';

import { SortAndFilterModel } from 'components/common/search-form/fields/filter-types';

import { MapToggle } from 'components/search/map/map-toggle';
import { SearchForm } from 'components/common/search-form/index';

export interface SidebarProps {
  searchResults: SearchResultsStore;
  isActive: boolean;
  l10n: ILocalization;
  routeStore?: any;
  withFilters?: boolean;
}

@withLocalization
@inject('searchResults', 'routeStore')
@observer
export class Sidebar extends React.Component<SidebarProps> {
  public static defaultProps = {
    isActive: false,
    l10n: null,
    withFilters: true
  };

  public scrollToTop() {
    window.scrollTo(0, 0);
  }

  public render() {
    const { searchResults, isActive, withFilters } = this.props;
    const searchCriteria = searchResults && searchResults.searchCriteria;
    const regionId = searchCriteria && searchCriteria.regionId;
    const latLong = searchCriteria && searchCriteria.latLong;
    const group = searchCriteria && searchCriteria.group;
    const { l10n } = this.props;
    const { formatText } = l10n;

    const searchResultsCriteria = searchResults && searchResults.searchCriteria;
    const sortAndFilterOptions: SortAndFilterModel = searchResults && searchResults.sortAndFilter && searchResults.sortAndFilter.options;
    const sortAndFilterDefaults: any = searchResults && searchResults.sortAndFilter && searchResults.sortAndFilter.defaults;
    const filters = searchResults && searchResults.searchAndFilterDisplayOptions && searchResults.searchAndFilterDisplayOptions.filters;
    const displayFields = filters && filters.displayFields;
    const ignoreFields = filters && filters.ignoreFields;
    const mapImage = searchResults && searchResults.map && searchResults.map.staticMapSrc;
    const pwaMapOverlay: boolean = Boolean(
      this.props.routeStore &&
        this.props.routeStore.queryParams &&
        this.props.routeStore.queryParams.pwaOverlay &&
        this.props.routeStore.queryParams.pwaOverlay === 'map'
    );
    const shouldShowSidebar = regionId || latLong || group || sortAndFilterOptions;
    const displayFieldsNoSort = displayFields && displayFields.filter(item => item !== 'sort');

    return (
      <>
        {shouldShowSidebar && (
          <section data-stid="desktop-sidebar">
            {searchResults && searchResults.map && (
              <Experiment name="PWA_SORT_TNL_THROTTLE">
                <ExperimentControl>
                  <Experiment name="PWA_Redesign_Sort_and_Filter_Phase_1">
                    <ExperimentControl>
                      <div className="all-b-padding-six uitk-card-separator-bottom">
                        <MapToggle isActive={isActive} mapImage={mapImage} />
                      </div>
                    </ExperimentControl>
                    <ExperimentVariant bucket={1}>
                      <div>
                        <MapToggle isActive={isActive} mapImage={mapImage} />
                      </div>
                    </ExperimentVariant>
                  </Experiment>
                </ExperimentControl>
                <ExperimentVariant bucket={1}>
                  <div className="all-b-padding-six uitk-card-separator-bottom">
                    <MapToggle isActive={isActive} mapImage={mapImage} />
                  </div>
                </ExperimentVariant>
              </Experiment>
            )}
            {withFilters && (
              <>
                <h3 className="is-visually-hidden">{formatText('hotels.searchResults.filtersDialog.title')}</h3>
                {!pwaMapOverlay && (
                  <Experiment name="PWA_SORT_TNL_THROTTLE">
                    <ExperimentControl>
                      <Experiment name="PWA_Redesign_Sort_and_Filter_Phase_1">
                        <ExperimentControl>
                          <SearchForm
                            className="all-b-padding-twelve uitk-dialog__search-form"
                            model={searchResultsCriteria}
                            sortAndFilterOptions={sortAndFilterOptions}
                            sortAndFilterDefaults={sortAndFilterDefaults}
                            provideDefaultSubmitButton={false}
                            displayFields={displayFields}
                            ignoreFields={ignoreFields}
                            autoSubmit={true}
                            searchable={true}
                            afterSubmit={this.scrollToTop}
                          />
                        </ExperimentControl>
                        <ExperimentVariant bucket={1}>
                          <SearchForm
                            className="all-b-padding-twelve uitk-dialog__search-form"
                            model={searchResultsCriteria}
                            sortAndFilterOptions={sortAndFilterOptions}
                            sortAndFilterDefaults={sortAndFilterDefaults}
                            provideDefaultSubmitButton={false}
                            displayFields={displayFieldsNoSort}
                            ignoreFields={ignoreFields}
                            autoSubmit={true}
                            searchable={true}
                            afterSubmit={this.scrollToTop}
                          />
                        </ExperimentVariant>
                      </Experiment>
                    </ExperimentControl>
                    <ExperimentVariant bucket={1}>
                      <SearchForm
                        className="all-b-padding-twelve uitk-dialog__search-form"
                        model={searchResultsCriteria}
                        sortAndFilterOptions={sortAndFilterOptions}
                        sortAndFilterDefaults={sortAndFilterDefaults}
                        provideDefaultSubmitButton={false}
                        displayFields={displayFields}
                        ignoreFields={ignoreFields}
                        autoSubmit={true}
                        searchable={true}
                        afterSubmit={this.scrollToTop}
                      />
                    </ExperimentVariant>
                  </Experiment>
                )}
              </>
            )}
          </section>
        )}
      </>
    );
  }
}
